class DatetimeHelperService {

    constructor(
        moment
    ) {
        'ngInject';

        this.moment = moment;
        this.localTimezoneString = new Date()
            .toLocaleTimeString('en-us', {timeZoneName: 'short'})
            .split(' ')
            .slice(-1)
            .pop()
        || ''
    }

    /***
     * Takes in a parsable UTC date string and converts it to the computer's local time zone.
     *
     * @param dateString    a date string (generally passed straight from the database) that is currently in UTC time
     *
     * @returns {string}
     */
    getLocalDatetimeFromUtc(dateString) {
        const date = new Date(dateString);
        const localTime = this.moment.utc([
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
        ]);

        return localTime.toISOString();
    }

}

export default DatetimeHelperService;


// WEBPACK FOOTER //
// ./app/common/datetime-helper/datetime-helper-service.js